export const pointRetraitSelectorItemProps = () => ({
  service: {
    type: Object,
    required: true
  },
  disabled: {
    type: Boolean,
    required: false,
    default: false
  },
  raisonsImpossible: {
    type: Array,
    required: false,
    default() {
      return [];
    }
  }
})

export const pointRetraitSelectorItemEmits = () => ([
  "click"
]);

export const usePointRetraitSelectorItem = (props, context) => {
  const position = computed(() => {
    return {
      lat: props.service.gps ? parseFloat(props.service.gps.latitude) : 0,
      lng: props.service.gps ? parseFloat(props.service.gps.longitude) : 0,
      title: props.service.description,
      description: props.service.adresse + (props.service.description.details ? `(${props.service.description.details})` : '')
    }
  })
  const hasPosition = computed(() => {
    return props.service.gps && props.service.gps.latitude && props.service.gps.longitude;
  })

  const clicked = () => {
    if (!props.disabled) {
      context.emit('click');
    }
  }

  return {
    position,
    hasPosition,
    clicked
  }
}